var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M33 18C33 26.2843 26.2843 33 18 33C9.71573 33 3 26.2843 3 18C3 9.71573 9.71573 3 18 3C26.2843 3 33 9.71573 33 18Z",
    fill: "#B0ADCB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4545 13.4545C13.8938 13.0152 14.6062 13.0152 15.0455 13.4545L18 16.409L20.9545 13.4545C21.3938 13.0152 22.1062 13.0152 22.5455 13.4545C22.9848 13.8939 22.9848 14.6062 22.5455 15.0455L19.591 18L22.5455 20.9545C22.9848 21.3938 22.9848 22.1061 22.5455 22.5455C22.1061 22.9848 21.3938 22.9848 20.9545 22.5455L18 19.591L15.0455 22.5455C14.6062 22.9848 13.8939 22.9848 13.4545 22.5455C13.0152 22.1062 13.0152 21.3938 13.4545 20.9545L16.409 18L13.4545 15.0455C13.0152 14.6062 13.0152 13.8938 13.4545 13.4545Z",
    fill: "#6F6C90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/CloseCircle.77071b0c4946c2f196317614e749fdfb.svg";
export { ForwardRef as ReactComponent };